module.exports = __webpack_public_path__ + "img/no-image.5b41f2b8.jpg";